import {
  AfterViewInit,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';

// services
import { TranslateService } from '@ngx-translate/core';

// Types
import {
  ProfileCollectionFacade,
  ProfileCollectionViewModel,
} from '@app/profile/components/profile-collection/profile-collection-reactive-store';
import { CollectionItemType } from '@app/profile/profile-api.model';
import { PopoverService } from '@app/shared/services/popover.service';

import { Observable } from 'rxjs';
import { SubscriberBaseDirective } from '@app/shared/components/subscriber-base/subscriber-base.directive';
import { DfButtonBasicComponent } from '@lib/fresco';

@Component({
  selector: 'dgx-type-facet-filter',
  templateUrl: './type-facet-filter.component.html',
  styleUrls: ['../profile-collection-filters.component.scss'],
})
export class TypeFacetFilter
  extends SubscriberBaseDirective
  implements AfterViewInit, OnInit, OnChanges
{
  @Input() public filterToFocus: string;

  @ViewChild('filterToggle')
  public filterToggle: DfButtonBasicComponent;

  public i18n = this.translateService.instant([
    'UserController_Type',
    'UserController_Content',
    'UserController_Achievements',
    'dgProfileOverview_LearningTitle',
    'Core_Achievements',
    'Core_ClearNumberFormat',
    'Core_Clear',
    'Core_Position',
    'Core_ShowResults',
    'dgProfileOverview_ViewAllSkills',
  ]);

  public vm$: Observable<ProfileCollectionViewModel>;

  public isPopoverOpen = false;

  public filterItems: {
    [key: string]: string[];
  } = {};

  constructor(
    private translateService: TranslateService,
    private popover: PopoverService,
    private profileCollectionFacade: ProfileCollectionFacade
  ) {
    super();
  }

  public ngOnInit() {
    this.vm$ = this.profileCollectionFacade.vm$;
    this.vm$.pipe(this.takeUntilDestroyed()).subscribe((vm) => {
      this.filterItems.type = vm.filter.type;
    });
  }

  public ngOnChanges(changes: SimpleChanges) {
    const filterToFocus = changes?.filterToFocus?.currentValue;
    if (filterToFocus === 'type') {
      this.setFocus(filterToFocus);
    }
  }

  public ngAfterViewInit() {
    this.setFocus(this.filterToFocus);
  }

  public setFocus(filterToFocus: string) {
    if (filterToFocus === 'type') {
      this.filterToggle?.elementRef?.nativeElement.focus();
    }
  }

  public typeToggled(event: Event, filterItem: CollectionItemType): void {
    event.stopPropagation();

    const isFilterItemSelected = this.filterItems.type.includes(
      filterItem.name
    );

    if (isFilterItemSelected) {
      this.filterItems.type = this.filterItems.type.filter(
        (i) => i !== filterItem.name
      );
    } else {
      this.filterItems.type = [...this.filterItems.type, filterItem.name];
    }
  }

  public popoverToggled(popoverState: boolean): void {
    this.isPopoverOpen = popoverState;
  }

  public closePopover(): void {
    this.profileCollectionFacade.updateFilterValues(
      'type',
      this.filterItems.type
    );
    this.popover.close();
  }

  public resetType(): void {
    this.profileCollectionFacade.resetFilterValue('type');
    this.closePopover();
  }
}
